import { Skeleton } from '@mui/material';

/**
 * @return {JSX.Element}
 * @constructor
 */
export const ReplySkeleton = (): JSX.Element => {
  return (
    <div className="flex my-4">
      <Skeleton
        className="self-end"
        animation="wave"
        variant="circular"
        width={40}
        height={40}
      />
      <Skeleton
        className="rounded-[24px] ml-3"
        animation="wave"
        variant="rectangular"
        width={570}
        height={200}
      />
    </div>
  );
};
